// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"232":"printing","594":"about","765":"crm","966":"login"}[chunkId] || chunkId) + "." + {"232":"f918e5c9","384":"be0b8344","594":"1c7ee3e5","761":"853366ed","765":"4d0c4f1d","847":"8ba46e68","966":"c25ac30f"}[chunkId] + ".css";
};